import { IEventBus, ISubscriptionId } from "../typings/event-bus";
import { EventBus } from "./event-bus";

export class ImageLoader {
    private static _instance: ImageLoader;
    private readonly eventBus: IEventBus;
    private lazyLoadSubscriptions: ISubscriptionId[];
    private lazyLoadingDistance: number = 500;
    private callbackActive: boolean = false;

    private constructor() {
        if (!this.fetchImages().length) {
            return;
        }

        this.eventBus = EventBus.instance;

        this.registerEvents();
        this.loadImagesNearViewport();
    }

    private fetchImages():HTMLImageElement[] {
        const images: NodeListOf<HTMLImageElement> = document.querySelector('.scope-dlp').querySelectorAll('img[data-src]');
        return Array.prototype.slice.call(images);
    }

    private registerEvents(): void {
        this.lazyLoadSubscriptions = this.eventBus.subscribe(["OrientationHasChanged", "WindowScrolled", "WindowSizeHasChanged"],
            this.loadImagesNearViewport.bind(this)
        );
    }

    private loadImagesNearViewport(): void {
        if (this.callbackActive) {
            return;
        }

        this.callbackActive = true;

        for (const image of this.fetchImages()) {
            const rect: ClientRect = image.getBoundingClientRect();
            if ((rect.bottom > 0 && (rect.top - this.lazyLoadingDistance) > window.innerHeight) ||
                (rect.top < 0 && rect.bottom < 0)) {
                continue;
            }
            this.loadImage(image as HTMLImageElement);
        }
        this.unsubscribeEvents();
        this.callbackActive = false;
    }

    private loadImage(image: HTMLImageElement): void {
        if (image.hasAttribute('data-srcset')) {
            image.srcset = image.getAttribute('data-srcset');
            image.removeAttribute('data-srcset');
        }
        image.src = image.getAttribute('data-src');
        image.removeAttribute('data-src');
    }

    private unsubscribeEvents(): void {
        if (!this.fetchImages().length) {
            this.eventBus.unsubscribe(this.lazyLoadSubscriptions);
        }
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }
}

ImageLoader.instance;